import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth()
  const history = useHistory()

  useEffect(() => {
    if (!loading && !isAuthenticated) {
      toast.error('Please sign in to access this page')
      history.push('/signin')
    }
  }, [isAuthenticated, loading, history])

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#0B1F3A'
      }}>
        <div style={{ color: 'white', fontSize: '18px' }}>Loading...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return null
  }

  return (
    <>
      {children}
      <ToastContainer />
    </>
  )
}

export default ProtectedRoute
